const venoaTheme = {
  colors: {
    accent: "#0066FF",
    accentLight: "#BDD7FF",
    link: "#0066FF"
  }
}

export default venoaTheme;